class HoneyBem {
  constructor(blockName, module) {
    let prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "hcr-";
    this.convertModifiersToClassNames = function mapModifiersObj(mods, base) {
      return Object.keys(mods).reduce((a, c) => mods[c] ? "".concat(a, " ").concat(base, "--").concat(c) : a, '').trim();
    };
    this.block = "".concat(prefix).concat(blockName);
    this.module = module;
  }
  /**
   * @deprecated use constructor instead.
   * @param blockName
   * @param module
   * @param prefix
   * @returns
   */
  static init(blockName, module, prefix) {
    return new HoneyBem(blockName, module, prefix);
  }
  b(mods, mixes) {
    const classArr = [this.block];
    // populating array with mods and mixes class strings
    mods && classArr.push(this.m(mods, this.block));
    mixes && classArr.push(this.mix(mixes));
    // concatenating after removing empty strings
    // and passing to this convert to map against css mapping, if any
    return this.convert(classArr.filter(current => current).join(' '));
  }
  e(children, mods, mixes) {
    const e = typeof children === 'string' ? "".concat(this.block, "__").concat(children) : "".concat(this.block).concat(children.reduce((acc, cur) => "__".concat(acc, "__").concat(cur)));
    const classArr = [e];
    // populating array with mods and mixes class strings
    mods && classArr.push(this.m(mods, e));
    mixes && classArr.push(this.mix(mixes));
    // concatenating after removing empty strings
    // and passing to this convert to map against css mapping, if any
    return this.convert(classArr.filter(current => current).join(' '));
  }
  m(mods, baseOverride) {
    const base = baseOverride || this.block;
    if (typeof mods === 'string') {
      // if modifier is a string chain it with base
      return "".concat(base, "--").concat(mods).trim();
    }
    if (mods instanceof Object && !Array.isArray(mods)) {
      // if object of modifiers given pass them all to the mapping/chaining function
      return this.convertModifiersToClassNames(mods, base).trim();
    }
    if (Array.isArray(mods)) {
      // remove null, false and empty array
      const cleanMods = mods.filter(mod => mod && (typeof mod === 'string' || mod instanceof Object));
      // map mod (either string or Object)
      const m = cleanMods.map(mod => {
        if (mod instanceof Object) {
          return this.convertModifiersToClassNames(mod, base);
        }
        return "".concat(base, "--").concat(mod);
      }).join(' '); // join modifier sets for every array item into one modifier string
      return m.trim();
    }
    return '';
  }
  mix(mix) {
    if (typeof mix === 'string') {
      // if string provided, pass it through
      return mix.trim();
    }
    if (Array.isArray(mix)) {
      // if array given, flatten all objects inside and concatenate resulting classes
      return mix.map(mixItem => {
        if (mixItem instanceof Object) {
          return this.convertMixesToClassNames(mixItem);
        }
        return mixItem;
      }).join(' ').trim();
    }
    if (mix instanceof Object) {
      // in case we have object, flatten keys depending of the value
      return this.convertMixesToClassNames(mix).trim();
    }
    return '';
  }
  convert(selectors) {
    if (this.module) {
      return selectors.padEnd(1).split(' ').map(a => {
        var _a;
        return ((_a = this.module) === null || _a === void 0 ? void 0 : _a.map[a]) ? this.module.map[a] : a;
      }).join(' ');
    }
    return selectors;
  }
  convertMixesToClassNames(mixObj) {
    return Object.keys(mixObj).filter(current => mixObj[current]).join(' ');
  }
}

export { HoneyBem as default };
